function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
var shared = {
  product: 'fashion',
  build_product: 'fashion'
};
var eventsData = {
  breadcrumbClicked: {
    name: 'Breadcrumb Interaction',
    data: _objectSpread({}, shared)
  },
  clickThroughToWebsite: {
    name: 'Click-through to Website',
    data: _objectSpread({}, shared)
  },
  productImpression: {
    name: 'Product Impression',
    data: _objectSpread(_objectSpread({}, shared), {}, {
      alternateView: 'false'
    })
  },
  fashionFooterInteraction: {
    name: 'Fashion Footer Interaction',
    data: _objectSpread({}, shared)
  }
};
export default function getTrackingData(key) {
  if (!(key in eventsData) || typeof window === 'undefined') return null;
  var eventData = JSON.parse(_JSON$stringify(eventsData[key]));
  var platform = window.innerWidth > 768 ? 'desktop' : 'mobile';
  eventData.data.platform = "".concat(platform, " web");
  return eventData;
}